import { forwardRef, type HTMLAttributes, type TableHTMLAttributes } from 'react';
import clsx from 'clsx';

export const Table = forwardRef<HTMLTableElement, TableHTMLAttributes<HTMLTableElement>>(
  ({ className, ...rest }, ref) => (
    <div className="w-full overflow-x-auto rounded-xl border border-border-tertiary bg-white">
      <table
        ref={ref}
        className={clsx('w-full border-collapse text-left text-sm text-text-primary', className)}
        {...rest}
      />
    </div>
  ),
);
Table.displayName = 'Table';

export const THead = forwardRef<HTMLTableSectionElement, HTMLAttributes<HTMLTableSectionElement>>(
  ({ className, ...rest }, ref) => (
    <thead
      ref={ref}
      className={clsx(
        'border-b border-border-tertiary bg-surface-secondary text-xs font-semibold uppercase tracking-wide text-text-secondary',
        className,
      )}
      {...rest}
    />
  ),
);
THead.displayName = 'THead';

export const TBody = forwardRef<HTMLTableSectionElement, HTMLAttributes<HTMLTableSectionElement>>(
  ({ className, ...rest }, ref) => (
    <tbody ref={ref} className={clsx('divide-y divide-border-secondary', className)} {...rest} />
  ),
);
TBody.displayName = 'TBody';

export const TR = forwardRef<HTMLTableRowElement, HTMLAttributes<HTMLTableRowElement>>(
  ({ className, ...rest }, ref) => (
    <tr ref={ref} className={clsx('transition-colors hover:bg-surface-secondary', className)} {...rest} />
  ),
);
TR.displayName = 'TR';

export const TH = forwardRef<HTMLTableCellElement, HTMLAttributes<HTMLTableCellElement>>(
  ({ className, ...rest }, ref) => (
    <th
      ref={ref}
      scope="col"
      className={clsx('px-4 py-3 text-left font-semibold', className)}
      {...rest}
    />
  ),
);
TH.displayName = 'TH';

export const TD = forwardRef<HTMLTableCellElement, HTMLAttributes<HTMLTableCellElement>>(
  ({ className, ...rest }, ref) => (
    <td ref={ref} className={clsx('px-4 py-3 align-middle', className)} {...rest} />
  ),
);
TD.displayName = 'TD';
